import { render, staticRenderFns } from "./e-form-tooltip.vue?vue&type=template&id=28afdfac&scoped=true"
import script from "./e-form-tooltip.vue?vue&type=script&lang=js"
export * from "./e-form-tooltip.vue?vue&type=script&lang=js"
import style0 from "./e-form-tooltip.vue?vue&type=style&index=0&id=28afdfac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28afdfac",
  null
  
)

export default component.exports